module.exports = __webpack_public_path__ + "static/gracanica-front-3c429d1140b137aa573c2a69277e3db8.jpg";